import React from 'react';
import { Link } from 'react-router';

const NavLink = props => (
  <Link
    {...props}
    activeClassName={props.activeClassName}
    activeStyle={{ fontWeight: 'bold' }}
  />
);

export default NavLink;
